export default __webpack_public_path__ + "media/brand2x.c2ae6b66.png";